import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  Calender,
  DropDown,
  InstantModel,
  TextInputForm,
  DropDownUI,
} from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate, Navigate } from "react-router-dom";
import {
  Buttons,
  Dltbtn,
  InstantCreate,
  ClickButton,
  Delete,
} from "../components/Buttons";
import PayMents from "../components/PayMents";
import { BiPlus } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { ValueContainer } from "react-select/animated";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment/moment";
const DOMAIN = "https://pskfancycrackers.com/api";

const SelectDrCr = [
  {
    value: "DR",
    label: "DR",
  },
  {
    value: "CR",
    label: "CR",
  },
];
const Paymentmethods = [
  {
    value: "cash",
    label: "cash",
  },
  {
    value: "gpay",
    label: "gpay",
  },
  {
    value: "paytm",
    label: "paytm",
  },
  {
    value: "phonepe",
    label: "phonepe",
  },
  {
    value: "card",
    label: "card",
  },
  {
    value: "others",
    label: "others",
  },
];
const alltax = [
  {
    value: "IGST@0%",
    label: "IGST@0%",
  },
  {
    value: "GST@0%",
    label: "GST@0%",
  },
  {
    value: "IGST@0.25%",
    label: "IGST@0.25%",
  },
  {
    value: "GST@0.25%",
    label: "GST@0.25%",
  },
  {
    value: "IGST@3%",
    label: "IGST@3%",
  },
  {
    value: "GST@3%",
    label: "GST@3%",
  },
  {
    value: "IGST@5%",
    label: "IGST@5%",
  },
  {
    value: "GST@5%",
    label: "GST@5%",
  },
  {
    value: "IGST@12%",
    label: "IGST@12%",
  },
  {
    value: "GST@12%",
    label: "GST@12%",
  },
  {
    value: "IGST@18%",
    label: "IGST@18%",
  },
  {
    value: "GST@18%",
    label: "GST@18%",
  },
  {
    value: "IGST@28%",
    label: "IGST@28%",
  },
  {
    value: "GST@28%",
    label: "GST@28%",
  },
];
// saleinvoice start
const SalesTaxInvoiceEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};

  //const handleCloseModal = () => setShowModal(false);
  // const handleShowModal = () => setShowModal(true);
  const [toggled, setToggled] = useState(false);
  const [tax_type, settax_type] = useState("");

  const initialState =
    type === "edit"
      ? {
          ...rowData,
          discount_all: rowData.discount || "0",
          overall_discount_amount: rowData.discount_amount || "0",
          subtotal: rowData.sub_total || "0",
          balance_amount: rowData.balance || "0",
          total: (
            parseFloat(rowData.sub_total || 0) -
            parseFloat(rowData.discount || 0)
          ).toFixed(2),
          product: rowData.product || [],
          payment_method: Array.isArray(rowData.payment_method)
            ? rowData.payment_method
            : typeof rowData.payment_method === "string"
            ? JSON.parse(rowData.payment_method || "[]")
            : [],
          bill_date:
            rowData.bill_date && moment(rowData.bill_date).isValid()
              ? moment(rowData.bill_date).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
        }
      : {
          party_name: "",
          lr_bill_no: "",
          vechile_no: "",
          bill_date: moment().format("YYYY-MM-DD"),
          state_of_supply: "",
          mobile_number: "",
          address: "",
          total: "",
          subtotal: "",
          paid: "",
          balance_amount: "",
          final_total: "",
          discount_all: "",
          overall_discount_amount: "",
          total_discountall: "",
          taxover_amt: "",
          taxover_percentage: "",
          round_off_checkbox: "",
          remark: "",
          paid_by: "",
          reference: "",
          overall_tax_percentage: "",
          overall_tax_amount: "",
          payment_method: [],
          product: [
            {
              product_id: "",
              product_name: "",
              qty: "",
              unit: "",
              price_unit: "",
              discount_percentage: "",
              discount_amt: "",
              tax_type: "",
              tax_percentage: "",
              tax_amt: "",
              CGST: "",
              SGST: "",
              IGST: "",
              total_amt: "",
            },
          ],
        };

  useEffect(() => {
    if (type === "edit" && rowData?.payment_method) {
      try {
        const parsedPayments = Array.isArray(rowData.payment_method)
          ? rowData.payment_method
          : JSON.parse(rowData.payment_method || "[]");
        setPaymentDetails(parsedPayments || []);
      } catch (error) {
        console.error("Error parsing payment_method:", error);
        setPaymentDetails([]);
      }
    }
  }, [type, rowData]);
  const [formData, setFormData] = useState(initialState);
  console.log(formData);
  const [formDataPartySales, setformDataPartySales] = useState({
    party_name: "",
    mobile_number: "",
    alter_number: "",
    email: "",
    company_name: "",
    gst_no: "",
    address: "",
    opening_balance: "",
    opening_date: "",
    ac_type: "",
  });
  const setLabel = (value, field) => {
    if (!value || !moment(value).isValid()) {
      console.error("Invalid date received in setLabel:", value);
      return;
    }
    setFormData({
      ...formData,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };

  const [paymentDetails, setPaymentDetails] = React.useState([]);

  const [newPayment, setNewPayment] = React.useState({
    payment_method: "",
    amount: "",
    balance: "",
  });
  // Assuming formData and paymentDetails are part of the component's state
  const handleAddPayment = () => {
    const totalPaymentAmount = paymentDetails.reduce(
      (total, payment) => total + (parseFloat(payment.amount) || 0),
      0
    );
    const balance = parseFloat(formData.total) || 0; // Use total instead of balance_amount

    if (newPayment.payment_method && newPayment.amount) {
      if (totalPaymentAmount + parseFloat(newPayment.amount) > balance) {
        alert(
          "Insufficient balance. The total payment amount exceeds the available balance."
        );
      } else {
        const updatedPayment = {
          ...newPayment,
          balance: (
            balance -
            (totalPaymentAmount + parseFloat(newPayment.amount))
          ).toFixed(2),
        };
        setPaymentDetails((prev) => [...prev, updatedPayment]);
        setNewPayment({ payment_method: "", amount: "", balance: "" });
      }
    } else {
      alert("Please select a payment method and enter an amount.");
    }
  };

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const companyId = localStorage.getItem("companyId");
        const response = await fetch(`${DOMAIN}/products.php?id=${companyId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        console.log("API Response:", responseData);
        setLoading(false);

        if (responseData.status === 200 && Array.isArray(responseData.data)) {
          const validData = responseData.data.filter(
            (item) => item && typeof item.product_name === "string"
          );
          setProductData(validData);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error.message);
      }
    };

    fetchProductData(); // Call fetchData directly in useEffect
  }, []);

  const [UnitData, setUnitData] = useState([]);
  const fetchUnitData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUnitData(); // Call fetchData directly in useEffect
  }, []);
  console.log("discount", formData.discount_all);
  console.log("discount_all", formData.total_discountall);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);

  // const [partySalesData, setPartySalesData] = useState([]);

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    try {
      const subtotal = parseFloat(formData.subtotal) || 0;
      const discountPercent = parseFloat(formData.discount_all) || 0;
      const discountAmount = (subtotal * discountPercent) / 100;
      const discountedTotal = subtotal - discountAmount;
      const taxPercent = formData.overall_tax_percentage
        ? parseFloat(formData.overall_tax_percentage.match(/\d+\.*\d*/)?.[0]) ||
          0
        : 0;
      const taxAmount = (discountedTotal * taxPercent) / 100;
      const finalTotal = discountedTotal + taxAmount;

      const sanitizedFormData = {
        ...formData,
        payment_method: paymentDetails,
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || "0",
          tax_percentage: product.tax_percentage || "0",
          CGST: product.CGST || "0",
          SGST: product.SGST || "0",
          IGST: product.IGST || "0",
          without_tax_amount: (
            (parseFloat(product.qty) || 0) *
              (parseFloat(product.price_unit) || 0) -
            (parseFloat(product.discount_amt) || 0)
          ).toFixed(2),
        })),
        sub_total: subtotal.toFixed(2),
        discount: formData.discount_all,
        overall_discount_amount: discountAmount.toFixed(2),
        overall_tax_percentage: formData.overall_tax_percentage,
        overall_tax_amount: taxAmount.toFixed(2),
        total: finalTotal.toFixed(2),
        balance: formData.balance_amount,
        sum_total: formData.product
          .reduce(
            (acc, row) =>
              acc +
              ((parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0) -
                (parseFloat(row.discount_amt) || 0)),
            0
          )
          .toFixed(2),
      };

      const companyId = localStorage.getItem("companyId");

      const response = await fetch(
        `${API_DOMAIN}/sales_taxinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sanitizedFormData),
        }
      );
      console.log(JSON.stringify(sanitizedFormData));

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.status === 200) {
        setFormData(initialState);
        setPaymentDetails([]);
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/sales/taxinvoice");
        }, 2000);
      } else {
        handleErrors(responseData);
      }
    } catch (error) {
      console.error("Error during submission:", error.message);
      errorAlert(error.message);
    }
  };

  const handleErrors = (responseData) => {
    if (responseData.status === 400) {
      toast.error(responseData.msg, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      setShowAlert(true);
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      setLoading(true);
      const companyId = localStorage.getItem("companyId");

      // Calculate sum_total (sum of without_tax_amount for all products)
      const sum_total = formData.product
        .reduce(
          (acc, row) =>
            acc +
            ((parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0) -
              (parseFloat(row.discount_amt) || 0)),
          0
        )
        .toFixed(2);

      // Calculate subtotal, discount, tax, and total
      const subtotal = parseFloat(formData.subtotal) || 0;
      const discountPercent = parseFloat(formData.discount_all) || 0;
      const discountAmount = (subtotal * discountPercent) / 100;
      const discountedTotal = subtotal - discountAmount;
      const taxPercent = formData.overall_tax_percentage
        ? parseFloat(formData.overall_tax_percentage.match(/\d+\.*\d*/)?.[0]) ||
          0
        : 0;
      const taxAmount = (discountedTotal * taxPercent) / 100;
      const total = (discountedTotal + taxAmount).toFixed(2);

      // Calculate paid amount from paymentDetails
      const paid = paymentDetails
        .reduce((acc, pm) => acc + (parseFloat(pm.amount) || 0), 0)
        .toFixed(2);

      // Calculate balance (total - paid)
      const balance = (parseFloat(total) - parseFloat(paid)).toFixed(2);

      const requestBody = {
        ...formData,
        payment_method: paymentDetails,
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || "0",
          tax_percentage: product.tax_percentage || "0",
          CGST: product.CGST || "0",
          SGST: product.SGST || "0",
          IGST: product.IGST || "0",
          without_tax_amount: (
            (parseFloat(product.qty) || 0) *
              (parseFloat(product.price_unit) || 0) -
            (parseFloat(product.discount_amt) || 0)
          ).toFixed(2),
        })),
        invoice_id: rowData.invoice_id,
        sub_total: subtotal.toFixed(2),
        discount: formData.discount_all,
        overall_discount_amount: discountAmount.toFixed(2),
        overall_tax_percentage: formData.overall_tax_percentage,
        overall_tax_amount: taxAmount.toFixed(2),
        total: total,
        sum_total: sum_total,
        paid: paid,
        balance: balance,
      };

      console.log("Sending requestBody to backend:", requestBody);

      const response = await fetch(
        `${API_DOMAIN}/sales_taxinvoice.php?id=${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      console.log("Backend response:", responseData);

      if (responseData.status === 200) {
        toast.success("Sales Tax Invoice updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/sales/taxinvoice");
        }, 2000);
      } else {
        toast.error(responseData.msg || "Failed to update invoice", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error updating invoice:", error.message);
      toast.error("Error updating invoice: " + error.message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  // Delete a row from the product list
  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };

  const handleAddRow = () => {
    const lastRow = formData.product[formData.product.length - 1];
    if (
      lastRow.product_id &&
      lastRow.qty &&
      lastRow.unit &&
      lastRow.price_unit &&
      lastRow.total_amt
    ) {
      setFormData((prevState) => ({
        ...prevState,
        product: [
          ...prevState.product,
          {
            product_id: "",
            product_name: "",
            qty: "",
            unit: "",
            price_unit: "",
            discount_percentage: "",
            discount_amt: "",
            tax_type: "",
            tax_percentage: "",
            tax_amt: "",
            total_amt: "",
          },
        ],
      }));
    } else {
      toast.error(
        "Please fill in all required fields in the last row before adding a new row"
      );
    }
  };
  const handleChangePartySales = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;

    setformDataPartySales({
      ...formDataPartySales,
      [fieldName]: value,
    });
  };

  // Handle change in paid amount
  const handlePaidChange = (e) => {
    const value = parseFloat(e.target.value) || 0;

    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: value,
    }));
  };
  const calculateTotal = (product) => {
    const totalAmount = product.reduce(
      (acc, row) => acc + (parseFloat(row.total_amt) || 0),
      0
    );
    const discountPercent = parseFloat(formData.discount_all) || 0;
    const discountAmount = (totalAmount * discountPercent) / 100;
    const discountedTotal = totalAmount - discountAmount;

    // Calculate tax amount based on overall_tax_percentage
    const taxPercent = formData.overall_tax_percentage
      ? parseFloat(formData.overall_tax_percentage.match(/\d+\.*\d*/)?.[0]) || 0
      : 0;
    const taxAmount = (discountedTotal * taxPercent) / 100;
    const finalTotal = discountedTotal + taxAmount;

    setFormData((prevData) => ({
      ...prevData,
      subtotal: totalAmount.toFixed(2),
      overall_discount_amount: discountAmount.toFixed(2),
      overall_tax_amount: taxAmount.toFixed(2),
      total: finalTotal.toFixed(2),
    }));
  };
  const handleDiscountChange = (e) => {
    const { value } = e.target;
    const discountPercent = parseFloat(value) || 0;
    const subtotalValue = parseFloat(formData.subtotal) || 0;

    const discountAmount = (subtotalValue * discountPercent) / 100;
    const discountedTotal = subtotalValue - discountAmount;

    // Calculate tax amount based on overall_tax_percentage
    const taxPercent = formData.overall_tax_percentage
      ? parseFloat(formData.overall_tax_percentage.match(/\d+\.*\d*/)?.[0]) || 0
      : 0;
    const taxAmount = (discountedTotal * taxPercent) / 100;
    const finalTotal = discountedTotal + taxAmount;

    setFormData((prevData) => ({
      ...prevData,
      discount_all: value,
      overall_discount_amount: discountAmount.toFixed(2),
      overall_tax_amount: taxAmount.toFixed(2),
      total: finalTotal.toFixed(2),
    }));
  };

  const handleRemarkChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePaidbyChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleReferencebyChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    var updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    updatedFormData.product.forEach((row, index) => {
      const qty = parseFloat(row.qty);
      const price = parseFloat(row.price_unit);
      const discountPercentage = parseFloat(row.discount_percentage);
      const discountInputAmount = parseFloat(row.discount_amt);
      const taxPercentage = parseFloat(row.tax_percentage);
      const taxtype = row.tax_type;

      let sgst = 0,
        cgst = 0,
        igst = 0;

      let crtdiscountFiled = 0.0;

      let subtotal = isNaN(qty) || isNaN(price) ? 0 : qty * price;

      if (fieldName === "price_unit") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : isNaN(subtotal)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt = crtdiscountFiled;
      }
      if (fieldName === "discount_percentage") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : isNaN(subtotal)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt = crtdiscountFiled;
      } else if (fieldName === "discount_amt") {
        crtdiscountFiled = isNaN(discountInputAmount) ? 0 : discountInputAmount;
        const cal = (crtdiscountFiled / subtotal) * 100;
        updatedFormData.product[index].discount_percentage = isNaN(cal)
          ? 0
          : parseFloat(cal).toFixed(2);
      }
      let tmpsubtotal = 0;
      if (fieldName === "tax_percentage") {
        tmpsubtotal =
          subtotal - (isNaN(discountInputAmount) ? 0 : discountInputAmount);
      } else {
        tmpsubtotal =
          subtotal - (isNaN(crtdiscountFiled) ? 0 : crtdiscountFiled);
      }

      let taxAmount =
        isNaN(tmpsubtotal) || isNaN(taxPercentage)
          ? 0
          : (tmpsubtotal * taxPercentage) / 100;

      let finalAmount = tmpsubtotal + taxAmount;

      if (taxtype === "IGST") {
        igst = taxAmount;
      } else {
        var gstamount = taxAmount / 2;
        cgst = gstamount;
        sgst = gstamount;
      }
      if (fieldName === "tax_percentage") {
      }

      updatedFormData.product[index].SGST = sgst.toFixed(2);
      updatedFormData.product[index].CGST = cgst.toFixed(2);
      updatedFormData.product[index].IGST = igst.toFixed(2);
      updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
      updatedFormData.product[index].total_amt = finalAmount.toFixed(2);
    });

    const totalAmount = updatedFormData.product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );
    updatedFormData.total = totalAmount.toFixed(2);

    setFormData(updatedFormData);
  };
  //console.log(formData);
  useEffect(() => {
    calculateTotal(formData.product);
  }, [formData.product]);
  useEffect(() => {
    const updateBalance = () => {
      const total = parseFloat(formData.total) || 0;
      const paidAmount = paymentDetails.reduce(
        (acc, pm) => acc + (parseFloat(pm.amount) || 0),
        0
      );

      const balance = total - paidAmount;

      setFormData((prevFormData) => ({
        ...prevFormData,
        balance_amount: balance.toFixed(2),
        paid: paidAmount.toFixed(2),
      }));
    };

    updateBalance();
  }, [formData.total, paymentDetails]);

  function calculateTax(product, tax_percentage, index, taxType) {
    let updatedFormData = { ...formData };
    let sgst = 0,
      cgst = 0,
      igst = 0;

    const productTotal = parseFloat(product.total_amt) || 0;
    const taxRate = parseFloat(tax_percentage.match(/\d+\.*\d*/)?.[0]) || 0;
    const taxAmount = productTotal - productTotal / (1 + taxRate / 100);

    console.log("tax_percentage", tax_percentage);

    if (taxType === "GST") {
      const gstAmount = taxAmount / 2;
      sgst = gstAmount;
      cgst = gstAmount;
    } else if (taxType === "IGST") {
      igst = taxAmount;
    }

    updatedFormData.product[index].SGST = sgst.toFixed(2);
    updatedFormData.product[index].CGST = cgst.toFixed(2);
    updatedFormData.product[index].IGST = igst.toFixed(2);
    updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
    updatedFormData.product[index].tax_type = taxType;

    setFormData(updatedFormData);
  }

  const defaultDate =
    type === "edit" ? formData.bill_date : new Date().toISOString();

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <div className="main" style={{ cursor: "pointer" }}>
        <Container fluid className="px-0">
          <Row>
            <Col lg="12" className="py-3">
              <PageHead
                pagehead={<>Sales Tax Invoice</>}
                onClick={() => navigate(-1)}
              />
            </Col>
            <Col lg="12" className="py-3">
              <Table>
                <tr>
                  <td>
                    <div className="party-on">
                      <Container>
                        <Row>
                          <Col lg="4" className="py-3">
                            <div className="d-flex">
                              <div className="w-250">
                                <TextInputForm
                                  placeholder={"Party Name"}
                                  labelname={"Party Name"}
                                  name="Party Name"
                                  value={formData.party_name}
                                  onChange={(e) =>
                                    handleChange(e, "party_name")
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg="4" className="py-3">
                            <div className="W-50">
                              <TextInputForm
                                placeholder={"Mobile Number"}
                                labelname={"Mobile Number"}
                                name="mobile_number"
                                value={formData.mobile_number}
                                onChange={(e) =>
                                  handleChange(e, "mobile_number")
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6" className="py-3">
                            <label className="pb-2">Address</label>
                            <textarea
                              className="form-cntrl form-control"
                              placeholder={"Address"}
                              labelname={"Address"}
                              name="address"
                                rows={6}   // 👈 taller
                              cols={50}
                              value={formData.address}
                              onChange={(e) => handleChange(e, "address")}
                            />
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </td>
                  <td className="mx-auto float-end">
                    <div>
                      <Calender
                        setLabel={(date) => setLabel(date, "bill_date")}
                        selectedDate={
                          formData.bill_date &&
                          moment(formData.bill_date).isValid()
                            ? moment(formData.bill_date).toDate()
                            : new Date()
                        }
                        calenderlabel="Bill Date"
                      />
                    </div>
                    <div>
                      <TextInputForm
                        placeholder={"LR Bill No"}
                        labelname={"LR Bill No"}
                        name="lr_bill_no"
                        value={
                          type === "edit"
                            ? formData.lr_bill_no
                            : formData.lr_bill_no
                        }
                        onChange={(e) => handleChange(e, "lr_bill_no")}
                      />
                    </div>
                    <div>
                      {" "}
                      <TextInputForm
                        placeholder={"VECHILE Number"}
                        labelname={"VECHILE Number"}
                        name="vechile_no"
                        value={
                          type === "edit"
                            ? formData.vechile_no
                            : formData.vechile_no
                        }
                        onChange={(e) => handleChange(e, "vechile_no")}
                      />{" "}
                    </div>
                    <div>
                      {" "}
                      <TextInputForm
                        placeholder={"State of Supply"}
                        labelname={"STATE OF SUPPLY"}
                        name="state_of_supply"
                        value={
                          type === "edit"
                            ? formData.state_of_supply
                            : formData.state_of_supply
                        }
                        onChange={(e) => handleChange(e, "state_of_supply")}
                      />{" "}
                    </div>
                  </td>
                </tr>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="main my-3">
        <div>
          <Container fluid className="px-0">
            <Row>
              <Col lg="12" className="py-3">
                <div>
                  No Of Products : <span>{formData.product.length}</span>
                </div>
              </Col>
              <Col lg="12" md="6" xs="12">
                <div className="py-2 category-table bill">
                  <Table>
                    <thead className="">
                      <tr>
                        <th rowSpan={2} className="wrdbrk w-10">
                          #
                        </th>
                        <th rowSpan={2} className="wrdbrk w-20">
                          Product Name
                        </th>
                        <th rowSpan={2} className="wrdbrk w-7">
                          Qty
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Unit
                        </th>
                        <th rowSpan={2} className="wrdbrk w-7">
                          Price / Unit
                        </th>

                        <th rowSpan={2} className="wrdbrk w-10">
                          Amount
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.product &&
                        formData.product.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <div>
                                <DropDownUI
                                  optionlist={productData.map((user) => ({
                                    value: user.product_id,
                                    label: `${user.product_name}`,
                                  }))}
                                  placeholder="ProductName"
                                  filterOption={(option, input) => {
                                    const searchText = input.toLowerCase();
                                    const product = productData.find(
                                      (p) => p.product_id === option.value
                                    );
                                    return (
                                      product.product_code
                                        .toLowerCase()
                                        .includes(searchText) ||
                                      product.product_name
                                        .toLowerCase()
                                        .includes(searchText)
                                    );
                                  }}
                                  name="product_id"
                                  value={row.product_id}
                                  onChange={(updatedFormData) => {
                                    const selectedProduct = productData.find(
                                      (user) =>
                                        user.product_id ===
                                        updatedFormData.product_id
                                    );

                                    const taxLabel = selectedProduct
                                      ? `GST@${selectedProduct.item_gst}%`
                                      : "GST@0%";

                                    setFormData({
                                      ...formData,
                                      product: formData.product.map((r, i) => {
                                        if (i === index) {
                                          const priceUnit = selectedProduct
                                            ? selectedProduct.unit_rate
                                            : 0;
                                          const qty = r.qty
                                            ? parseFloat(r.qty)
                                            : 0;

                                          // ✅ recalc total
                                          const totalAmt = (
                                            qty * priceUnit
                                          ).toFixed(2);

                                          return {
                                            ...r,
                                            product_id:
                                              updatedFormData.product_id,
                                            product_name: selectedProduct
                                              ? selectedProduct.product_name
                                              : "",
                                            price_unit: priceUnit,
                                            tax_type: "GST",
                                            tax_percentage: selectedProduct
                                              ? selectedProduct.item_gst
                                              : 0,
                                            tax_label: taxLabel,
                                            unit: selectedProduct.unit_id,
                                            total_amt: totalAmt,
                                          };
                                        }
                                        return r;
                                      }),
                                    });
                                  }}
                                  autoFocus={
                                    index === formData.product.length - 1
                                  }
                                />
                              </div>

                              {/* <div>
                                
                              </div> */}
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"qty"}
                                name="qty"
                                value={row.qty}
                                onChange={(e) => handleChange(e, "qty", index)}
                              ></TextInputForm>
                            </td>
                            <td>
                              <DropDownUI
                                optionlist={UnitData.map((user) => ({
                                  value: user.unit_id,
                                  label: user.unit_name,
                                }))}
                                placeholder="Unit"
                                name="unit"
                                value={row.unit}
                                onChange={(updatedFormData) =>
                                  setFormData({
                                    ...formData,
                                    product: formData.product.map((r, i) =>
                                      i === index
                                        ? { ...r, unit: updatedFormData.unit }
                                        : r
                                    ),
                                  })
                                }
                              />
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"price"}
                                name="price"
                                value={row.price_unit}
                                onChange={(e) =>
                                  handleChange(e, "price_unit", index)
                                }
                              />
                            </td>

                            <td>
                              <TextInputForm
                                placeholder={"amt"}
                                name="total_amt"
                                value={row.total_amt}
                                onChange={(e) =>
                                  handleChange(e, "total_amt", index)
                                }
                              />
                            </td>
                            <td className="d-none">
                              <div className="d-none">
                                {index === formData.product.length - 1 && (
                                  <ClickButton
                                    label={<>Add More</>}
                                    onClick={handleAddRow}
                                  />
                                )}
                              </div>
                            </td>
                            <td>
                              <Delete
                                onClick={() => handleDeleteRow(index)}
                                label={<MdDeleteForever />}
                              ></Delete>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
                <div className="text-end mt-3">
                  <ClickButton label={<>Add More</>} onClick={handleAddRow} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="my-3">
          <Container>
            <Row>
              <Col lg="5">{/* <PayMents /> */}</Col>
              <Col lg="7">
                <div className="inside my-3">
                  <Table>
                    <tr></tr>
                    <tr>
                      <td>Sub Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"SubTotal"}
                          name="Subtotal"
                          value={
                            type === "edit"
                              ? formData.subtotal
                              : formData.subtotal
                          }
                          onChange={handlePaidChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Discount</td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Discount"}
                          name="discount_all"
                          value={formData.discount_all}
                          onChange={handleDiscountChange}
                        />
                      </td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Discount Amount"}
                          name="overall_discount_amount"
                          value={formData.overall_discount_amount}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Tax</td>
                      <td className="w-25">
                        <DropDownUI
                          optionlist={alltax}
                          placeholder="Tax Percentage"
                          name="overall_tax_percentage"
                          value={formData.overall_tax_percentage || ""}
                          onChange={(updatedFormData) => {
                            const selectedValue =
                              updatedFormData.overall_tax_percentage;
                            const taxPercent = selectedValue
                              ? parseFloat(
                                  selectedValue.match(/\d+\.*\d*/)?.[0]
                                ) || 0
                              : 0;
                            const subtotalValue =
                              parseFloat(formData.subtotal) || 0;
                            const discountPercent =
                              parseFloat(formData.discount_all) || 0;
                            const discountAmount =
                              (subtotalValue * discountPercent) / 100;
                            const discountedTotal =
                              subtotalValue - discountAmount;
                            const taxAmount =
                              (discountedTotal * taxPercent) / 100;
                            const finalTotal = discountedTotal + taxAmount;

                            setFormData({
                              ...formData,
                              overall_tax_percentage: selectedValue,
                              overall_tax_amount: taxAmount.toFixed(2),
                              total: finalTotal.toFixed(2),
                            });
                          }}
                        />
                      </td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Tax Amount"}
                          name="overall_tax_amount"
                          value={formData.overall_tax_amount}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Total"}
                          name="total"
                          value={formData.total}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Payment Method</td>
                      <td></td>
                      <td className="w-25">
                        {/* Dropdown to select payment method */}
                        <DropDownUI
                          optionlist={Paymentmethods}
                          placeholder="Payment Methods"
                          name="payment_method"
                          value={newPayment.payment_method}
                          onChange={(updatedValue) => {
                            setNewPayment((prev) => ({
                              ...prev,
                              payment_method: updatedValue.payment_method, // Update method
                            }));
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Amount</td>
                      <td></td>
                      <td>
                        {/* Input to enter payment amount */}
                        <TextInputForm
                          type="number"
                          value={newPayment.amount}
                          placeholder="Enter Amount"
                          onChange={(e) => {
                            setNewPayment((prev) => ({
                              ...prev,
                              amount: e.target.value, // Update amount
                            }));
                          }}
                        />
                        {/* Button to add the payment detail */}
                        <ClickButton
                          label={"AddPayment"}
                          onClick={() => {
                            const totalPaymentAmount = paymentDetails.reduce(
                              (total, payment) =>
                                total + parseFloat(payment.amount),
                              0
                            );
                            const remainingBalance =
                              formData.total - totalPaymentAmount;
                            if (
                              remainingBalance >= parseFloat(newPayment.amount)
                            ) {
                              if (
                                newPayment.payment_method &&
                                newPayment.amount
                              ) {
                                newPayment.balance =
                                  remainingBalance -
                                  parseFloat(newPayment.amount);
                                setPaymentDetails((prev) => [
                                  ...prev,
                                  newPayment,
                                ]); // Add to list
                                setNewPayment({
                                  payment_method: "",
                                  amount: "",
                                  balance: "",
                                }); // Reset input
                              } else {
                                alert(
                                  "Please select a payment method and enter an amount."
                                );
                              }
                            } else {
                              alert(
                                "Insufficient balance. The total payment amount exceeds the available balance."
                              );
                            }
                          }}
                        ></ClickButton>
                      </td>
                    </tr>
                    <tr>
                      <td>Payment Details</td>
                      <td></td>
                      <td>
                        <div>
                          <ul>
                            {paymentDetails.map((payment, index) => (
                              <li key={index}>
                                {payment.payment_method}:{" "}
                                {Number(payment.amount).toFixed(2)} Rs
                              </li>
                            ))}
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Balance</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"balance"}
                          name="balance_amount"
                          value={
                            type === "edit"
                              ? formData.balance_amount
                              : formData.balance_amount
                          }
                          onChange={handlePaidChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>Remark</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder="Remarks"
                          name="remark"
                          value={formData.remark}
                          onChange={(e) => {
                            handleRemarkChange(e, "remark");
                          }}
                          className="m-3"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Paid By</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Paid By"}
                          name="paid_by"
                          value={formData.paid_by}
                          onChange={(e) => handlePaidbyChange(e, "paid_by")}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Reference</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Reference"}
                          name="reference"
                          value={formData.reference}
                          onChange={(e) =>
                            handleReferencebyChange(e, "reference")
                          }
                        />
                      </td>
                    </tr>
                  </Table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="main stick-bottom">
        <div className="w-50 ms-auto">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                        ></ClickButton>
                      </span>

                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/sales/taxinvoice")}
                        ></ClickButton>
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                        ></ClickButton>
                      </span>

                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/sales/taxinvoice")}
                        ></ClickButton>
                      </span>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};
// saleinvoice end

export default SalesTaxInvoiceEntry;
